<template>
    <div>
        <h2>Logging In</h2>
    </div>
</template>
<script>
export default {
    name : 'login-via-url',
    props: {'token':String},
    methods: {
        async loginViaUrl(urlToken) {
            const endpoint = `${this.$hostname}/api/login-via-url/${encodeURIComponent(urlToken)}`;

            try {
                const response = await fetch(endpoint, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const data = await response.json();
                console.log('Login successful:', data);
                return data;
            } catch (error) {
                console.error('Error during login via URL:', error);
                throw error;
            }
        }
    },

    beforeRouteEnter (to, from, next) { 
        next(vm => { 
            // vm.$socket.emit('login-via-token', {urlToken: vm.$props.token})
            // vm.$store.commit('set-url-access-token', vm.$props.token)

            vm.loginViaUrl(vm.$props.token)
            .then(data => {
                // Handle successful login
                console.log(data);
                
                vm.$store.commit('set-token', data.authendifiactionString)
                if(data.route){
                    vm.$router.push(data.route)
                }
            })
            .catch(error => {
                // Handle login error
                console.error(error);
            });

            next();
        }) 
    }

}
</script>